import scale from "@ui/design-tokens/03.space/space";
import type { SystemStyleObject } from "@ui/types";

import { getRelativeWidthToVW } from "@ui/utils/relativeWidth";

export const styles = {
    container: {
        alignItems: "center",
        justifyContent: "space-between",
        gap: 0.2,
        mt: 1,
        px: 4,
        bg: "gray.50",
        pr: 0,
        w: ["100%", "100%", "100%", "calc(90% + 50px)"],
    },
    progress: {
        w: "full",
    },
    innerWrapper: {
        pr: 4,
        w: "full",
        alignItems: "center",
        gap: 2,
    },
    button: {
        whiteSpace: "wrap",
        borderStart: "1px solid white",
        textDecoration: "udnerline",
        _disabled: {
            color: "gray.600",
            cursor: "not-allowed",
        },
    },
    tooltipIcon: {
        display: "block",
        cursor: "pointer",
        position: "relative",
    },
    tooltip: {
        flex: "flex-end",
        display: "flex",
        p: 4,
        mr: [0, 0, 0, 4],
        border: `${scale["0.2"]} solid`,
        width: [getRelativeWidthToVW(30), getRelativeWidthToVW(30), getRelativeWidthToVW(30), 320],
        maxWidth: "unset",
        ml: [3, 3, 3, 0],
    },
} satisfies Record<string, SystemStyleObject>;
